import _ from "lodash";
import * as Backbone from "backbone";

export const FavStatusView = Backbone.View.extend({
	className: 'FavStatusView',
	events: {
		'click .FavStatusActivateButton': 'activate',
		'click .FavStatusDeactivateButton': 'deactivate',
		'click .FavStatusOkEvent': 'ok',
		'click .FavStatusAbortEvent': 'abort',
	},
	initialize: function (options) {
		_.bindAll(this, _.functionsIn(this));
		this.selpan = options.selpan;
		this.showActivateButton = options.showActivateButton;
		this.render();
		this.listenTo(this.selpan.status, 'change:favKey', this.render);
		this.listenTo(this.selpan.collection, "choiceModeChanged", this.render);
		this.listenTo(this.selpan, 'showUserQuestion', this.showUserQuestion);
		if (this.showActivateButton) this.listenTo(this.selpan.collection, "done:applyVisibility", this.refresh);
	},
	isVisibleAndFavEqual: function () {
		let vis = this.selpan.collection.getVisibleModels();
		let fav = this.selpan.getFavModels();
		return !_.xor(vis, fav).length;
	},
	/**
	 *
	 * @param {Object} data
	 * @param {$.Deferred} data.receiverDefer
	 */
	showUserQuestion: function (data) {
		if (!data || !data.receiverDefer) return;
		if (this.receiverDefer && this.receiverDefer.state() === 'pending') this.receiverDefer.reject();
		this.receiverDefer = data.receiverDefer;
		this.receiverDefer.always(this.render);
		this.render();
	},
	ok: function () {
		if (this.receiverDefer) this.receiverDefer.resolve();
		// this.selpan.saveFavCustom()
	},
	abort: function () {
		if (this.receiverDefer) this.receiverDefer.reject();
	},
	activate: function () {
		this.selpan.selectOnlyActiveFavModels();
	},
	deactivate: function () {
		this.selpan.selectOnlyThese([]);
	},
	templateOkCancel: _.template('<div class="MenuCenter">\n\t<div class="MenuButton MenuItem FavStatusOkEvent MenuInline">\n\t\t<div class="MenuInline MenuIcon"><i class="fa fa-check""></i></div>\n\t\t<div class="MenuInline MenuLabel">OK</div>\n\t</div>\n\t<div class="MenuButton MenuItem MenuInline FavStatusAbortEvent">\n\t\t<div class="MenuInline MenuIcon"><i class="fa fa-times""></i></div>\n\t\t<div class="MenuInline MenuLabel">Abbrechen</div>\n\t</div>\n</div>'),
	// language=HTML
	template: _.template('<% if(v.showActivateButton) { %>\n<div class="FavStatusViewControl FavStatusActivateButton MenuItem MenuButton MenuRight" title="Alle aktivieren">\n\t<i class="fa fa-check-square-o"></i>\n</div>\n<div class="FavStatusViewControl FavStatusDeactivateButton MenuItem MenuButton MenuRight" title="Alle deaktivieren">\n\t<i class="fa fa-square-o"></i>\n</div>\n<% } %>\n<div class="MenuItemPassive"\n\t\t title="Mit den Favoriten können Sie sich eine Untermenge aus der Auswahlliste (z.B. Abteilungen oder Partien) zusammenstellen, die Sie bearbeiten wollen. Diese haben Sie bequem in jeder Applikation verfügbar.">\n\t<div class="FavStatusViewIcon MenuInline MenuIcon">\n\t\t<i class="fa <%= v.icon %>"></i>\n\t</div>\n\t<div class="FavStatusViewText MenuInline MenuLabel"><%= v.favName %></div>\n</div>\n'),
	refresh: function () {
		if (!this.$c || this.selpan.collection.isSingleChoiceMode()) return;
		let vfeq = this.isVisibleAndFavEqual();
		this.$c.activate.toggleClass('MenuAccentBack', !vfeq);
	},
	render: function () {
		//todo enter edit mode - render ok and abort button
		if (this.receiverDefer && this.receiverDefer.state() === 'pending') {
			this.$el.html(this.templateOkCancel());
		} else {
			let favName = this.selpan.status.get('favKey');
			let icon = 'fa-star';
			if (favName === undefined) {
				favName = 'Alle';
				icon = 'fa-star-o';
			}
			this.$el.html(this.template({
				v: {
					showActivateButton: this.showActivateButton && !this.selpan.collection.isSingleChoiceMode(),
					favName: favName,
					icon: icon,
				},
			}));
			this.$c = {
				activate: this.$('.FavStatusActivateButton'),
			};
			this.refresh();
		}
	},
});
